import {
  Banner,
  WhoWeAre,
  Stats,
  Video,
  Catalogue,
  Factory,
  ContactForm,
  QuickAbout,
  TradingProducts,
} from "../components";

function Home() {
  return (
    <>
      <Banner />
      <WhoWeAre />
      <QuickAbout />
      <Stats />
      <Video />
      <Catalogue />
      <TradingProducts />
      <Factory />
      <ContactForm />
    </>
  );
}

export default Home;
